/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardExpensesDetailRouteConfiguration: IAppRouterConfiguration[] = [
    {
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.expensesAccounts,
            EBreadCrumbType.expensesDetail,
        ],
        path: RoutePath.wizardExpensesDetail,
    },
    {
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.expensesAccountId,
            EBreadCrumbType.expensesDetail,
        ],
        path: RoutePath.wizardExpensesDetailAccountId,
    },
];
